import React, { useContext, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';

import moment from 'moment';

import { Formik } from 'formik';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';
import SpinnerLoading from '../feedback/spinnerLoading';

import { addEventsToPatient /* , updatePatientEvents */ } from '../../utils/comms';

import { newPatientEventVS } from '../../utils/formValidations';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function AddEventDialog({ enrolmentData, eventInfo, eventTypes, handleClose, handleFeedback, idUser, open, title }) {
  const sessionContext = useContext(SessionContext);

  // const [eventData, setEventData] = useState(eventInfo ? { date: eventInfo.date, type: eventInfo.type } : { date: '', type: '' });
  const [showLoading, setShowLoading] = useState(false);

  /* const handleChangeEvent = (value, field) => {
    const eventDataCopy = { ...eventData }; // Sembla que és més eficient que fer const eventDataCopy = Object.assign({}, eventData)
    eventDataCopy[field] = value;
    setEventData(eventDataCopy);
  }; */

  const addEvent = async (myEvent, resetForm) => {
    setShowLoading(true);
    // Afegim l'event. Els events només es poden afegir als pacients
    const responseAddEventsToPatient = await addEventsToPatient([{ type: myEvent.type, program: enrolmentData.program._id, date: myEvent.date, assignedClinician: myEvent.assignedTo }], enrolmentData._id, idUser, sessionContext.userToken);
    setShowLoading(false);
    if (responseAddEventsToPatient.status === 200) {
      // Tornam eventData als valors incials per si es torna a obrir el componnent no mostri el valor anteriorment seleccionat
      resetForm();
      handleClose();
      handleFeedback('success', 'AddEventToPatient', true);
    } else if (responseAddEventsToPatient === 'timeOut') { // Si hi ha hagut un error durant el procés, miram si ha estat de tipus timeOut
      handleFeedback('error', 'TimeOut', false);
    } else if (responseAddEventsToPatient === 409) { // No es pot afegir l'event perque ja n'hi ha un creat i no es pot repetir
      handleFeedback('error', 'AddEventToPatientAlreadyExists', false);
    } else { // Altres tipus d'error
      handleFeedback('error', 'AddEventToPatient', false);
    }
  };

  const closeDialog = (resetForm) => {
    // Tornam eventData als valors incials per si es torna a obrir el componnent no mostri el valor anteriorment seleccionat
    resetForm();
    // handleClose(false); // Amb false indicam al handleClose que el pare NO ha de mostrar la nova llista de programes
    handleClose();
  };

  // ATENCIÓ: el servidor només té implementada la creació i eliminació d'esdeveniments.
  // De moment (25/09/20) aquesta funció no fa res, la deix al codi per si en un futur la necessit
  /* const editEvent = async () => {
    setShowLoading(true);
    const response = await updatePatientEvents([{ _id: eventInfo._id, type: eventData.type, date: eventData.date }], idUser, sessionContext.userToken);
    setShowLoading(false);
    // Tornam eventData als valors incials per si es torna a obrir el componnent no mostri el valor anteriorment seleccionat
    setEventData({ date: '', type: '' });
    if (response.status === 200) { // Event creat/modificat
      handleClose(true); // Amb true indicam al handleClose que el pare ha de mostrar la nova llista d'events
      handleFeedback('success', 'UpdatePatientEvent');
    } else if (response === 'timeOut') { // El servidor està caigut o l'usuari no té connexió
      handleFeedback('error', 'TimeOut');
    } else { // Error amb les dades o al servidor
      handleFeedback('error', 'UpdatePatientEvent');
    }
  }; */

  // ATENCIÓ: el servidor només té implementada la creació i eliminació d'esdeveniments.
  /* const manageAction = () => {
    if (!eventInfo) {
      addEvent();
    } else {
      editEvent();
    }
  }; */

  // Com que en principi només hi toca haver un administrador de l'equip clínic, en lloc de recorrer tot l'array
  // feim un find del primer clinician que té admin a true
  const defaultAssignedTo = () => {
    const adminClinician = enrolmentData.supervisedBy.find((clinician) => clinician.admin === true);
    return adminClinician.clinician._id;
  };

  // Els events que no estan gestionats des de ICHOM_web no es poden afegir des de la web
  // Si està gestionat per ICHOM_web tornam disableItem com a false
  const disableItem = (managedBy) => {
    return !managedBy.some((manager) => manager === 'ICHOM_web');    
  };

  return (
    <Formik
      initialValues={{
        date: '',
        assignedTo: defaultAssignedTo(),
        type: '',
      }}
      validationSchema={newPatientEventVS}
      onSubmit={(values, { resetForm }) => { addEvent(values, resetForm); }}
    >
      {({ values, touched, errors, handleChange, handleBlur, resetForm, submitForm }) => (
        <div>
          {/* <SpinnerLoading show={showLoading} /> // Si el pos aquí per pantalla no es veu, queda davall del dialog */}
          <Dialog
            open={open}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            fullWidth
            maxWidth='md'
          >
            <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
            <DialogContent>
              <SpinnerLoading show={showLoading} />
              <Grid container spacing={2} justify='space-around'>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id='eventType-label' variant='outlined' error={Boolean(touched.type && errors.type)}>{translations['_eventType']}</InputLabel>
                    <Select
                      labelId='eventType-label'
                      label={translations['_eventType']}
                      variant='outlined'
                      id='type'
                      name='type'
                      error={Boolean(touched.type && errors.type)}
                      value={values.type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      // className={classes.selectEmpty}
                    >
                      <MenuItem key='eventType_empty' value=''> </MenuItem>
                      {eventTypes.map((element) => <MenuItem key={`eventType_${element._id}`} value={element._id} disabled={disableItem(element.managedBy)}>{translations[element.desc] || element.desc}</MenuItem>)}
                    </Select>
                    <FormHelperText error>{touched.type && errors.type ? errors.type : ''}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id='assignedTo-label' variant='outlined' error={Boolean(touched.assignedTo && errors.assignedTo)}>{translations['_assignedTo']}</InputLabel>
                    <Select
                      labelId='assignedTo-label'
                      label={translations['_assignedTo']}
                      variant='outlined'
                      id='assignedTo'
                      name='assignedTo'
                      error={Boolean(touched.assignedTo && errors.assignedTo)}
                      value={values.assignedTo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      // className={classes.selectEmpty}
                    >
                      <MenuItem key='assignedTo_empty' value=''> </MenuItem>
                      {enrolmentData.supervisedBy.map((clinician) => <MenuItem key={`assignedTo_${clinician.clinician._id}`} value={clinician.clinician._id}>{clinician.clinician.username}</MenuItem>)}
                    </Select>
                    <FormHelperText error>{touched.assignedTo && errors.assignedTo ? errors.assignedTo : ''}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={translations['_eventTypeDate']}
                    variant='outlined'
                    type='date'
                    id='date'
                    name='date'
                    error={Boolean(touched.date && errors.date)}
                    value={values.date && moment(values.date).format('YYYY-MM-DD')} // Per adequar el format de la data al que necessita el TextField
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.date && errors.date ? errors.date : ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <BasicButton handleClick={submitForm} type='accept' />
              <BasicButton handleClick={() => closeDialog(resetForm)} type='cancel' />
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Formik>
  );
}

// Indica i controla els props que se han de passar al component
AddEventDialog.propTypes = {
  enrolmentData: PropTypes.object.isRequired,
  eventInfo: PropTypes.object, // Pot ser null
  eventTypes: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  idUser: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
